var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"height-100 width-100"},[_c('AnalyticsTable',{class:{ 'pb-12': _vm.isLoading },attrs:{"tableData":_vm.tableData,"customColumns":_vm.customColumns}}),(_vm.isLoading)?_c('AppLoader',{staticClass:"mt-n8"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }